<script setup lang="ts">
// NPM
import { ref } from 'vue';
import { useRoute } from 'vue-router';

// Components
import { BaseButton } from '@magma-app/magma-lapilli';

// This page must NOT make any API calls: while the IP is blocked every request
// returns 403 and would loop straight back here.
// Prefer the IP from the URL query (survives anything, shareable), then fall back
// to sessionStorage set by the API interceptor during the live ban.
const route = useRoute();
const queryIp = typeof route.query.ip === 'string' ? route.query.ip : '';
const blockedIp = ref<string>(queryIp || sessionStorage.getItem('magma_blocked_ip') || '');

const contactSupport = () => {
  const subject = encodeURIComponent('Access blocked - help needed');
  const body = encodeURIComponent(
    blockedIp.value ? `My IP address: ${blockedIp.value}` : ''
  );
  window.location.href = `mailto:csm@magma.app?subject=${subject}&body=${body}`;
};
</script>

<template>
  <div class="gradient__grey__07 flex min-h-screen flex-col items-center justify-center p-8">
    <div class="text-center sm:w-[360px]">
      <img
        class="mx-auto h-20 w-20 rounded-full object-cover ring-[5px] ring-border-on-emphasis"
        src="/img/logo_magma.png"
      />

      <h1
        class="mx-auto mt-8 text-mgm-txt-lg font-semibold text-foreground-emphasis"
      >
        {{ $t('blockedView.title') }}
      </h1>

      <p
        class="mx-auto mt-3 text-mgm-txt-md text-foreground-subtle"
      >
        {{ $t('blockedView.description') }}
      </p>

      <BaseButton
        class="mt-8 w-full"
        :text="$t('blockedView.contact')"
        size="md"
        type="button"
        @click="contactSupport"
      />

      <p
        v-if="blockedIp"
        class="mt-6 text-mgm-txt-sm text-foreground-subtle"
      >
        {{ $t('blockedView.ipLabel') }}: <span class="font-medium">{{ blockedIp }}</span>
      </p>
    </div>
  </div>
</template>
